import React from "react";
import { Icon } from "Icons/index";
import LoaderIcon from "Components/loader/LoaderIcon";
import cx from "classnames";
import s from "./buttonIcon.scss";

class ButtonIcon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { active, className, data, disabled, hoverSmall, icon, iconSize, loading, notHover, onClick, square, title } =
      this.props;

    return (
      <div
        className={cx(className, s.buttonIcon, {
          [s.active]: active,
          [s.square]: square,
          [s.hover]: !notHover && !disabled && !loading,
          [s.hoverSmall]: !notHover && !disabled && !loading && hoverSmall,
          [s.disabled]: disabled,
          [s.loading]: loading,
        })}
        onClick={(e) => {
          !disabled && !loading && onClick !== undefined && onClick(e);
        }}
        disabled={disabled}
        ref={this.props.innerRef}
        {...data}
        title={!disabled && !loading ? title : ""}
      >
        {!loading && (
          <Icon
            className={s.icon}
            svg={icon}
            width={iconSize ? iconSize : "1rem"}
            height={iconSize ? iconSize : "1rem"}
            // onClick={onClik}
          />
        )}

        {loading && <LoaderIcon className={s.icon} iconSize="1rem" color="var(--text-a40)" />}
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <ButtonIcon innerRef={ref} {...props} />);
